// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-information {\n  width: 950px !important;\n  height: 700px;\n}\n", "",{"version":3,"sources":["webpack://./src/Components/DialogInformation/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;AACf","sourcesContent":[".dialog-information {\n  width: 950px !important;\n  height: 700px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
